<template>
	<div class="message-list-wrapper">
		<EmptyPage :height="588" :loading="loading" v-if="list.length === 0" />
		<div v-else>
			<div class="message-list">
				<div
					class="message-list__item"
					v-for="(item, index) in list"
					:key="index"
				>
					<!-- 系统通知 -->
					<template v-if="[4,11].includes(item.noticetype)">
						<div class="item-avatar">
							<svg-icon
								icon-class="noticeIcon4"
								class-name="icon-noticeIcon"
							></svg-icon>
						</div>
						<div class="item-mid">
							<div class="mid-title">
								<h3>系统消息</h3>
								<span class="mid-title__time">{{ item.createTime }}</span>
							</div>
							<div class="mid-content" v-html="linkify(item.content)"></div>
						</div>
					</template>
					<template v-else>
						<div class="item-avatar" @click="openUserDetail(item.avatarId)">
							<img :src="item.avatar || avatarUrl" alt="" />
						</div>
						<div class="item-mid">
							<div class="mid-title">
								<h3
									class="mid-title__name"
									@click="openUserDetail(item.avatarId)"
								>
									{{ item.name }}
								</h3>
								<span class="mid-title__time">{{ item.createTime }}</span>
							</div>
							<div class="mid-content">
								{{ item.content }}
							</div>
						</div>
						<div
							class="item-btn"
							v-if="[1, 2, 5].indexOf(item.noticetype) > -1"
						>
							<el-button
								type="primary"
								plain
								size="small"
								@click="openDetail(item)"
								>查看详情</el-button
							>
						</div>
						<div class="item-btn" v-else-if="item.noticetype === 3">
							<el-button
								type="primary"
								plain
								size="small"
								@click="openUserDetail(item.avatarId)"
								>查看粉丝</el-button
							>
						</div>
					</template>
				</div>
			</div>

			<div class="loading" v-show="scrollLoading">
				<i class="el-icon-loading"></i>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { openWindow } from "@/utils/utils";
import { getMessageList } from "@/api/message";
import EmptyPage from "@/components/EmptyPage";

export default {
	name: "MessageList",
	components: { EmptyPage },
	inject: ["backTop"],
	props: {
		type: {
			type: [String, Number],
			default: 1,
		},
	},
	data: () => ({
		loading: true,
		total: 0,
		pageSize: 10,
		pageNum: 1,
		pages: 1,
		list: [],
		avatarUrl: "/static/images/user.png",
		scrollLoading: false,
	}),
	computed: {
		...mapState("user", ["userInfo"]),
		...mapState("app", ["scrollStatus"]),
	},
	watch: {
		type() {
			this.loading = true;
			this.list = [];
			this.initPageParams();
			this.getData();
		},
		scrollStatus() {
			if (!this.scrollLoading) {
				this.scroll();
			}
		},
	},
	mounted() {
		this.initPageParams();
		this.getData();
	},
	methods: {
		initPageParams() {
			this.pageNum = 1;
			this.pageSize = 10;
			this.total = 0;
			this.pages = 1;
		},
		handlePageChange(pageNum) {
			this.pageNum = pageNum;
			this.backTop();
			this.getData();
		},
		async getData() {
			try {
				const params = {
					userid: this.userInfo.id,
					noticetype: this.type,
					pageSize: this.pageSize,
					pageNum: this.pageNum,
				};
				const { code, data } = await getMessageList(params);
				if (code === 0) {
					const add = data.result.map(item => {
						return {
							id: item.id,
							name: item.frdName,
							avatar: item.frdUserLogo,
							avatarId: item.friendId,
							noticetype: item.noticetype,
							createTime: moment(item.createTime).format("YYYY-MM-DD HH:mm:ss"),
							content:
								item.noticetype === 4 ? item.noticecontent : item.content,
							typeid: item.typeid,
							tp: item.tp,
						};
					});
					this.list = [...this.list, ...add];
					this.total = data.total;
					this.pages = data.pages;
				}
			} catch (e) {
				throw e;
			} finally {
				this.loading = false;
				this.scrollLoading = false;
			}
		},
		linkify(text) {
            // 匹配文本中的网站链接
            const urlRegex = /((?:(?:https?|ftp):\/\/|www\.)[^\s<\u4e00-\u9fa5]+[^\s<\u4e00-\u9fa5\.)])/gi;
            const urls = text.match(urlRegex);

            // 如果没有匹配到链接，直接返回原文本
            if (!urls) {
                return text;
            }

            // 遍历所有匹配到的链接，将其替换为a标签
            for (let i = 0; i < urls.length; i++) {
                const url = urls[i];
                const link = `<a href="${url}" target="_blank">${url}</a>`;
                text = text.replace(url, link);
            }

            return text;
		},

		// 无限滚动
		scroll() {
			if (this.pageNum > 100) return;
			if (this.pageNum >= this.pages) return;
			this.scrollLoading = true;
			this.pageNum++;
			this.getData();
		},
		openDetail(item) {
			const tpArr = [
				"/#/experience/detail/",
				"/#/works/detail/",
				"/#/forum/detail/",
			];

			openWindow(tpArr[item.tp - 1] + item.typeid);
		},
		openUserDetail(id) {
			if (!id) return;
			this.$router.push({
				name: "User",
				params: { id },
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.message-list-wrapper {
	background-color: rgba(255, 255, 255, 1);
	border-radius: 10px;
	overflow: hidden;
	margin-top: 20px;
	min-height: 588px;

	.message-list {
		padding: 30px;
		&__item {
			display: flex;

			&:not(:first-child) {
				margin-top: 40px;
			}

			.item-avatar {
				display: flex;
				margin-right: 15px;
				width: 90px;
				height: 90px;
				font-size: 90px;
				border-radius: 50%;

				img {
					width: 90px;
					height: 90px;
					border-radius: 50%;
					cursor: pointer;
				}

				.icon-noticeIcon {
					font-size: 90px;
				}
			}

			.item-mid {
				flex: 1;
				display: flex;
				flex-direction: column;
				.mid-title {
					height: 30px;
					display: flex;
					align-items: center;
					@include font(rgba(39, 44, 64, 1), 14px, 400);
					h3 {
						margin-right: 15px;
						@include font(rgba(39, 44, 64, 1), 16px, 600);
					}

					&__name:hover {
						color: rgba(47, 84, 235, 1);
						cursor: pointer;
					}

					&__time {
						@include font(rgba(113, 119, 152, 1), 14px, 400);
					}
					a {
						@include font(rgba(47, 84, 235, 1), 14px, 400);

						&:hover {
							text-decoration: underline;
							@include font(rgba(47, 84, 235, 1), 14px, 400);
						}
					}
				}
				.mid-content {
					margin-top: 15px;
					@include font(rgba(39, 44, 64, 1), 14px, 400);

					a {
						@include font(rgba(47, 84, 235, 1), 14px, 400);

						&:hover {
							text-decoration: underline;
							@include font(rgba(47, 84, 235, 1), 14px, 400);
						}
					}
				}
			}

			.item-btn {
				width: 120px;
				height: 90px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-left: 10px;
			}
		}

		&__pagination {
			margin-top: 45px;
			text-align: center;
		}
	}
}

.loading {
	margin: 20px 0;
	text-align: center;
	font-size: 32px;
}

// 小屏
@include mq($small) {
	.message-list-wrapper {
		margin-top: 15px;

		.message-list {
			&__item {
				&:not(:first-child) {
					margin-top: 30px;
				}

				.item-avatar {
					margin-right: 10px;
					width: 60px;
					height: 60px;

					img {
						width: 60px;
						height: 60px;
					}

					.icon-noticeIcon {
						font-size: 60px;
					}
				}

				.item-mid {
					.mid-title {
						h3 {
							margin-right: 15px;
						}
						p {
							margin-right: 15px;
						}
					}
					.mid-content {
						margin-top: 10px;
					}
				}
			}

			&__pagination {
				margin-top: 30px;
				text-align: center;
			}
		}
	}
}
</style>
